import type { QueryClient } from "@tanstack/react-query";
import type { LoaderFunctionArgs } from "react-router-dom";
import {
  getClientsOptions,
  getLeadsOptions,
  getOrganizationOptions,
  getUserOptions,
} from "../../../services";

export const buildLayoutLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    if (!params.organizationId) throw new Error("Organization ID is required");

    const t0 = performance.now();
    sessionStorage.setItem("dashboard-nav-start", String(t0));

    // Kick off all 4 in parallel. User populates the cache in the background
    // — it is not awaited so it doesn't delay navigation.
    queryClient.ensureQueryData(getUserOptions())
      .then(() => console.log(`[LOADER] user: ${(performance.now() - t0).toFixed(0)}ms`));

    // Await the three queries the home page needs — keeps the spinner going
    // until the content is actually ready to render. ExistingLeadRow calls
    // useGetClient (useSuspenseQuery) per lead row, so clients must be ready
    // before navigation completes or the inner Suspense will briefly block.
    await Promise.all([
      queryClient.ensureQueryData(getOrganizationOptions(params.organizationId))
        .then(() => console.log(`[LOADER] organization: ${(performance.now() - t0).toFixed(0)}ms`)),
      queryClient.ensureQueryData(getLeadsOptions(params.organizationId))
        .then(() => console.log(`[LOADER] leads: ${(performance.now() - t0).toFixed(0)}ms`)),
      queryClient.ensureQueryData(getClientsOptions(params.organizationId))
        .then(() => console.log(`[LOADER] clients: ${(performance.now() - t0).toFixed(0)}ms`)),
    ]);

    console.log(`[LOADER] done (spinner stops): ${(performance.now() - t0).toFixed(0)}ms`);
    return null;
  };
